export interface FooterLink {
  name: string;
  path: string;
}

export interface FooterLinkSection {
  title: string;
  links: FooterLink[];
}

export const footerLinks: FooterLinkSection[] = [
  {
    title: 'Company',
    links: [
      { name: 'About Us', path: '/about' },
      { name: 'Services', path: '/services' },
      { name: 'Fleet', path: '/fleet' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { name: 'Airport Transfers', path: '/services#airport' },
      { name: 'Corporate Travel', path: '/services#corporate' },
      { name: 'Event Transportation', path: '/services#events' },
      { name: 'Road Shows', path: '/services#roadshows' },
    ],
  },
  {
    title: 'Fleet',
    links: [
      { name: 'Sedans', path: '/fleet#sedans' },
      { name: 'SUVs', path: '/fleet#suvs' },
      { name: 'Premium SUVs', path: '/fleet#premium-suvs' },
      { name: 'Buses', path: '/fleet#buses' },
      { name: 'View All', path: '/fleet' },
    ],
  },
  {
    title: 'Support',
    links: [
      { name: 'FAQs', path: '/faqs' },
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
    ],
  },
];

